module.exports = __webpack_public_path__ + "img/icon_logo.be8d490a.png";